export { NileSplitPanel } from './nile-split-panel';